import { connect } from 'react-redux';

import Sidebar from './Sidebar';

const mapStateToProps = (state) => ({
  showRightSidebar: state.Layout.showRightSidebar,
});

export default connect(mapStateToProps, null)(Sidebar);
